import Vuex from 'vuex'
import Vue from 'vue'
import createPersiste from 'vue-savedata'
import wx from "weixin-js-sdk";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    imgUrl:"",
    selected_card: '', //用户选择的银行卡
    address: {}, //用户编辑的地址
    address_type: 'add',
    expiry_time: '', //token失效时间
  },
  mutations: {
    update_selected_card(state, payload) {
      state.selected_card = payload
    },
    set_address(state, payload) {
      state.address = payload
    },
    set_address_type(state, payload) {
    	state.address_type = payload
    },
    update_expiry_time(state, payload) {
      state.expiry_time = payload
    },
    setImgUrl(state,value){
        state.imgUrl = value;
        sessionStorage.setItem("imgUrl", value);
    },
  },
  //缓存所有store数据到本地 也可以单独缓存
  plugins: [createPersiste()],
})

export default store;